"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("../../../utils/helpers");
var _VideoSlideModule = _interopRequireDefault(require("./../../../scss/slide-layouts/VideoSlide.module.scss"));
require("./../../../scss/slide-layouts/VideoSlide.scss");
function VideoSlide() {
  const playerRef = (0, _react.useRef)(null);
  const bcPlayer = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (playerRef.current !== null && bcPlayer.current === null) {
      // load the video player here            
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    ref: playerRef,
    id: `video-player-`,
    className: (0, _helpers.classes)([_VideoSlideModule.default['video-wrapper'], 'video-slide__video-wrapper'])
  }));
}
var _default = exports.default = VideoSlide;